import _asyncToGenerator from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _toConsumableArray from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { keys, pick, get as _get, set as _set, isEmpty, values, uniq } from 'lodash';
import URI, { parseQuery } from 'urijs';
import { AUTH_INITIALIZED, UPDATE_AUTH_CREDS, CLEAR_AUTH_CREDS, OAUTH_SIGNUP_SUCCESS, OAUTH_SIGNUP_ERROR, OAUTH_SIGNIN_SUCCESS, OAUTH_SIGNIN_ERROR, EMAIL_SIGNUP_CONFIRMATION_SUCCESS, EMAIL_SIGNUP_CONFIRMATION_ERROR, PASSWORD_RESET_CONFIRMATION_SUCCESS, PASSWORD_RESET_CONFIRMATION_ERROR, PERSIST_THROUGH_REDIRECT, LOAD_AFTER_REDIRECT } from '../constants';
import { normalizeTokenKeys } from '../oauth/browser';
export function parseLocationCreds(_ref) {
  var location = _ref.location,
      headerKeys = _ref.headerKeys,
      confirmationKeys = _ref.confirmationKeys,
      userType = _ref.userType;

  if (!location) {
    return {};
  }

  var uri = URI(location);
  var params = normalizeTokenKeys(parseQuery(uri.query()));

  if (params.endpointKey !== userType) {
    return {};
  }

  var confirmationCreds = pick(params, uniq([].concat(_toConsumableArray(headerKeys), _toConsumableArray(values(confirmationKeys)))));
  var confirmationType;

  if (params[confirmationKeys.oauth_registration]) {
    confirmationType = {
      success: OAUTH_SIGNUP_SUCCESS,
      error: OAUTH_SIGNUP_ERROR
    };
  } else if (params[confirmationKeys.emailSignUp]) {
    confirmationType = {
      success: EMAIL_SIGNUP_CONFIRMATION_SUCCESS,
      error: EMAIL_SIGNUP_CONFIRMATION_ERROR
    };
  } else {
    confirmationType = {
      success: PASSWORD_RESET_CONFIRMATION_SUCCESS,
      error: PASSWORD_RESET_CONFIRMATION_ERROR
    };
  }

  if (isEmpty(confirmationCreds)) {
    confirmationCreds = null;
    confirmationType = null;
  }

  return {
    confirmationCreds: confirmationCreds,
    confirmationType: confirmationType
  };
}
export function stripCreds(_ref2) {
  var location = _ref2.location,
      removeKeys = _ref2.removeKeys;

  if (!location) {
    return null;
  }

  var nextUrl = URI(location).removeQuery(removeKeys).toString();
  return nextUrl;
} // default session handler. uses class instance memory. meant for use on
// the server.

var BaseSessionHandler = /*#__PURE__*/function () {
  function BaseSessionHandler() {
    var _this = this;

    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        client = _ref3.client,
        getState = _ref3.getState,
        validateToken = _ref3.validateToken,
        dispatchAction = _ref3.dispatchAction,
        location = _ref3.location,
        redirect = _ref3.redirect,
        headerKeys = _ref3.headerKeys,
        confirmationKeys = _ref3.confirmationKeys,
        _ref3$reducerName = _ref3.reducerName,
        reducerName = _ref3$reducerName === void 0 ? 'auth' : _ref3$reducerName,
        _ref3$userType = _ref3.userType,
        userType = _ref3$userType === void 0 ? 'user' : _ref3$userType,
        _ref3$onConfirmSucces = _ref3.onConfirmSuccess,
        onConfirmSuccess = _ref3$onConfirmSucces === void 0 ? function () {} : _ref3$onConfirmSucces,
        _ref3$onConfirmError = _ref3.onConfirmError,
        onConfirmError = _ref3$onConfirmError === void 0 ? function () {} : _ref3$onConfirmError,
        mapUrlCredsToHeaders = _ref3.mapUrlCredsToHeaders,
        requestCookies = _ref3.requestCookies,
        setResponseCookie = _ref3.setResponseCookie,
        clearResponseCookie = _ref3.clearResponseCookie;

    _classCallCheck(this, BaseSessionHandler);

    this.creds = {};
    this.getState = getState;
    this.headerKeys = headerKeys;
    this.userType = userType;
    this.reducerName = reducerName;
    this.dispatchAction = dispatchAction.bind(client);
    this.requestCookies = requestCookies;
    this.setResponseCookie = setResponseCookie;
    this.clearResponseCookie = clearResponseCookie;
    this.isInitialized = new Promise(function (resolve) {
      _this.resolveInitialization = resolve;
    });
    this.initialize({
      getState: getState,
      reducerName: reducerName,
      userType: userType,
      validateToken: validateToken,
      headerKeys: headerKeys,
      confirmationKeys: confirmationKeys,
      location: location,
      redirect: redirect,
      onConfirmSuccess: onConfirmSuccess,
      onConfirmError: onConfirmError,
      mapUrlCredsToHeaders: mapUrlCredsToHeaders
    });
  } // the client should read from the store to see if any auth credentials were
  // passed down from the server. this will prevent redundant validation
  // requests.


  _createClass(BaseSessionHandler, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
        var getState, validateToken, headerKeys, confirmationKeys, location, redirect, onConfirmSuccess, onConfirmError, mapUrlCredsToHeaders, userType, creds, redirectState, _parseLocationCreds, confirmationCreds, confirmationType, sessionCreds, authType, redirectUrl;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getState = _ref4.getState, validateToken = _ref4.validateToken, headerKeys = _ref4.headerKeys, confirmationKeys = _ref4.confirmationKeys, location = _ref4.location, redirect = _ref4.redirect, onConfirmSuccess = _ref4.onConfirmSuccess, onConfirmError = _ref4.onConfirmError, mapUrlCredsToHeaders = _ref4.mapUrlCredsToHeaders, userType = _ref4.userType;
                // check if we've arrived via cred-strip redirect. this will only have any
                // consequence when using SSR and when rendering on the server
                redirectState = this.loadAfterRedirect();

                if (!redirectState) {
                  _context.next = 6;
                  break;
                }

                this.dispatchAction({
                  type: LOAD_AFTER_REDIRECT,
                  payload: redirectState
                });
                this.resolveInitialization();
                return _context.abrupt("return");

              case 6:
                // check for creds sent by confirmation redirects
                _parseLocationCreds = parseLocationCreds({
                  location: location,
                  headerKeys: headerKeys,
                  confirmationKeys: confirmationKeys,
                  mapUrlCredsToHeaders: mapUrlCredsToHeaders,
                  userType: userType
                }), confirmationCreds = _parseLocationCreds.confirmationCreds, confirmationType = _parseLocationCreds.confirmationType; // check the store to see if this user has any existing creds. these will
                // have been set by the server

                if (getState) {
                  creds = _get(getState(), "".concat(this.credsKey(), ".creds"));
                } // save the server-set creds to the session if found


                if (isEmpty(creds)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return this.set(creds);

              case 11:
                _context.next = 13;
                return this.get();

              case 13:
                sessionCreds = _context.sent;

                if (!(!getState && !sessionCreds && !isEmpty(confirmationCreds))) {
                  _context.next = 17;
                  break;
                }

                this.resolveInitialization();
                return _context.abrupt("return");

              case 17:
                if (!(isEmpty(creds) && (!isEmpty(sessionCreds) || !isEmpty(confirmationCreds)))) {
                  _context.next = 33;
                  break;
                }

                if (isEmpty(confirmationCreds)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 21;
                return this.set(confirmationCreds);

              case 21:
                _context.prev = 21;
                _context.next = 24;
                return validateToken();

              case 24:
                if (confirmationType) {
                  this.dispatchAction({
                    type: confirmationType.success
                  });
                  onConfirmSuccess({
                    type: confirmationType.success
                  });
                }

                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](21);

                if (confirmationType) {
                  this.dispatchAction({
                    type: confirmationType.error
                  });
                  onConfirmError({
                    type: confirmationType.error
                  });
                }

              case 30:
                _context.next = 32;
                return this.get();

              case 32:
                creds = _context.sent;

              case 33:
                // dispatch an event to indicate that we found existing valid creds
                this.dispatchAction({
                  type: AUTH_INITIALIZED,
                  payload: creds
                }); // strip confirmation creds out of URL

                if (!isEmpty(confirmationCreds) && confirmationCreds['access-token']) {
                  this.dispatchAction({
                    type: PERSIST_THROUGH_REDIRECT
                  });

                  if (this.getState) {
                    this.persistThroughRedirect(_get(this.getState(), this.reducerName));
                  }

                  authType = confirmationCreds.oauth_registration ? 'sign-up' : 'login';
                  redirectUrl = stripCreds({
                    location: location,
                    removeKeys: uniq([].concat(_toConsumableArray(values(confirmationKeys)), _toConsumableArray(keys(confirmationCreds))))
                  }) + "&auth=".concat(authType);
                  redirect(redirectUrl);
                }

                this.resolveInitialization();

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[21, 27]]);
      }));

      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "credsKey",
    value: function credsKey() {
      return [this.reducerName, this.userType].join('.');
    }
  }, {
    key: "set",
    value: function () {
      var _set2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(creds) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _set(this.creds, this.credsKey(), creds);

                this.dispatchAction({
                  type: UPDATE_AUTH_CREDS,
                  payload: creds
                });
                return _context2.abrupt("return", Promise.resolve(creds));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function set(_x2) {
        return _set2.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var creds;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                creds = _get(this.creds, this.credsKey());
                return _context3.abrupt("return", Promise.resolve(creds));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function get() {
        return _get2.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _set(this.creds, this.credsKey(), null);

                this.dispatchAction({
                  type: CLEAR_AUTH_CREDS
                });
                return _context4.abrupt("return", Promise.resolve());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function clear() {
        return _clear.apply(this, arguments);
      }

      return clear;
    }() // these methods will be overridden by the server-side SSR store

    /* eslint-disable class-methods-use-this */

  }, {
    key: "persistThroughRedirect",
    value: function persistThroughRedirect() {}
  }, {
    key: "loadAfterRedirect",
    value: function loadAfterRedirect() {}
    /* eslint-enable class-methods-use-this */

  }]);

  return BaseSessionHandler;
}();

export { BaseSessionHandler as default };